import { render, staticRenderFns } from "./storeType.vue?vue&type=template&id=cf4ba642&"
import script from "./storeType.vue?vue&type=script&lang=js&"
export * from "./storeType.vue?vue&type=script&lang=js&"
import style0 from "./storeType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports